import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import imgModelMobile from "assets/splashpage/mobile_va.png";
import imgModel from "assets/splashpage/vamoneybacksplash2.png";
import { DiscoverViewContext } from "contexts/DiscoverView";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { UpgradeDialogSource } from "schemas/dashboard";
import { Plans } from "schemas/payments";

import styles from "./styles";

const VAPreviewPage = () => {
  const { discoverTab } = useContext(DiscoverViewContext);
  const { setUpgradeDialogSource, setOpenCheckoutDialog } =
    useContext(SubscriptionContext);
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(
    theme.breakpoints.down(discoverTab ? "lg" : "md"),
  );
  const location = useLocation();
  const isMediumScreen =
    useMediaQuery(
      discoverTab !== null ? "(max-width:1400px)" : "(max-width:1200px)",
    ) && !isMobileScreen;

  const checkoutVaPage = () => {
    setUpgradeDialogSource(UpgradeDialogSource.va_preview);
    setOpenCheckoutDialog({
      plan: Plans.VA_YEARLY,
      pageSource: location.pathname,
      source: UpgradeDialogSource.va_preview,
    });
  };

  const rightSide = (
    <Grid container item xs md sx={styles.rightSidebar(isMediumScreen)}>
      <Box>
        <Box sx={[styles.chip, { mb: 2 }]}>🔒 Locked feature</Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h2" sx={styles.header}>
            <Box component="span" sx={styles.mainHeader}>
              🔒 Your Virtual Assistant:
            </Box>{" "}
          </Typography>

          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontSize: { xs: 14, md: 18 } }}
          >
            Bento AI Sends All of Your Pitches on Autopilot
          </Typography>
        </Box>

        <Typography variant="h4" sx={{ color: "purple.dark" }}>
          How it works
        </Typography>

        <Typography variant="body1" sx={{ mb: 3, mt: 1 }}>
          <Box component="ol" sx={{ pl: 2 }}>
            <li>You choose your niches (unlimited!) 💻 🏠 💄🐶</li>
            <li>Bento writes + sends pitches daily 📥</li>
            <li>Replies land in your inbox 💸</li>
          </Box>
        </Typography>

        <Button
          variant="contained"
          sx={{
            px: { xs: 2, md: 4 },
            py: 1.5,
            fontSize: { xs: 14, md: 16 },
            borderRadius: 10,
            textTransform: "none",
          }}
          disableElevation
          onClick={checkoutVaPage}
        >
          Let Bento Pitch For Me{" "}
          <Box
            component="i"
            className="fa-regular fa-arrow-right"
            sx={{ ml: 1 }}
          />
        </Button>

        {!isMobileScreen && (
          <Typography sx={{ mt: 3, fontSize: { xs: 16 } }}>
            <em>
              Virtual assistant users are{" "}
              <Box component="span" sx={{ color: "#00B74C", fontWeight: 700 }}>
                33x more likely
              </Box>{" "}
              to land brand deals.
            </em>
          </Typography>
        )}
      </Box>
    </Grid>
  );

  return (
    <Box sx={isMobileScreen ? { p: 3 } : styles.main}>
      <Grid
        gap={2}
        container
        sx={{
          background: "white",
          borderRadius: 4,
          maxWidth: 1200,
        }}
      >
        {isMobileScreen && rightSide}

        {isMobileScreen ? (
          <Grid container justifyContent={"center"} flexDirection={"column"}>
            <Box
              src={imgModelMobile}
              component="img"
              sx={{ width: "100%" }}
            ></Box>

            <Typography textAlign="center" sx={{ my: 1 }}>
              <em>
                Virtual assistant users are{" "}
                <Box
                  component="span"
                  sx={{ color: "#00B74C", fontWeight: 600 }}
                >
                  33x more likely
                </Box>{" "}
                to land brand deals.
              </em>
            </Typography>
          </Grid>
        ) : (
          <Grid item xs={12} lg={5} sx={styles.leftSidebar}>
            <Grid
              container
              gap={1}
              item
              xs={12}
              justifyContent={isMobileScreen ? "center" : "flex-start"}
            >
              <Box sx={styles.chip}>
                📩 300+ emails sent for you every month
              </Box>
              <Box sx={styles.chip}>Tier-one customer support</Box>
              <Box sx={[styles.chip, { backgroundColor: "yellow.main" }]}>
                💸 Exclusive Brand Pay Data
              </Box>
            </Grid>

            <Grid container justifyContent={"center"}>
              <Box
                src={imgModel}
                component="img"
                sx={styles.image(discoverTab !== null)}
              ></Box>
            </Grid>
          </Grid>
        )}

        {!isMobileScreen && rightSide}
      </Grid>
    </Box>
  );
};

export default VAPreviewPage;
